import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Shell from "./Shell";

// BrowserRouter added 2026-09-18: every page now has its own URL, so a
// refresh (F5) stays on the page you were on instead of dropping back to
// the gateway, and the Comp/Blended vertical survives in ?stack=. Old
// Minerva does the same thing with its Angular routes + ?stackId=.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  </React.StrictMode>
);
